import React, { useEffect,  useState } from 'react';
import { StoreItem } from './StoreItem';
// import Select from '@material-ui/core/Select';
// import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
// import { InputLabel } from '@material-ui/core';
// import { useForm } from 'react-hook-form';
import { useServices } from '../../hooks/useServices';
import LinearProgress from '@material-ui/core/LinearProgress';
import { OfertaError } from '../oferta/OfertaError';


export const StoreElige = () => {


      const [estados, setEstados] = useState([]);
      const [municipios, setMunicipios] = useState([]);
      const [colonias, setColonias] = useState([]);
      const [tiendas, setTiendas] = useState([]);

      const [idEstado, setIdEstado] = useState(null);
      const [idMunicipio, setIdMunicipio] = useState(null);
      const [idColonia, setIdColonia] = useState(null);

      const [errorRequestEstados, setErrorRequestEstados] = useState(false);
      const [errorRequestMunicipios, setErrorRequestMunicipios] = useState(false);
      const [errorRequestColonias, setErrorRequestColonias] = useState(false);
      const [errorRequestTiendas, setErrorRequestTiendas] = useState(false);

      const [loadingEstados, setLoadingEstados] = useState(false);
      const [loadingMunicipios, setLoadingMunicipios] = useState(false);
      const [loadingColonias, setLoadingColonias] = useState(false);
      const [loadingTiendas, setLoadingTiendas] = useState(false);

      // const { register,  watch } = useForm();
      
      // let watchEdo = watch('edoId');
      // let watchMun = watch('munId');
      // let watchCol = watch('colId');


      const { getCol, getEdos, getMun, getTiendas } = useServices();


      useEffect(() => {
        setIdColonia(null);
        setErrorRequestEstados(false);
        setMunicipios([]);
        setColonias([]);
        setTiendas([]);
        async  function fetchInitialData() {
          //console.log('cargo estados');
          setLoadingEstados(true);
          const response = await getEdos();
          if (response) {
            response.status ? setErrorRequestEstados(true) : setEstados(response);
            setLoadingEstados(false);
          } else{
            setErrorRequestEstados(true);
            setLoadingEstados(false);
          }
        }
        fetchInitialData();
        
      }, []);


      useEffect(() => {
        setIdColonia(null);
        setErrorRequestMunicipios(false);
        setMunicipios([]);
        setColonias([]);
        async function fetchMunicipios() {
         // console.log('cargo municipios');
          setLoadingMunicipios(true);
          const response = await getMun(idEstado);
          if (response ) {
            response.status ? setErrorRequestMunicipios(true) : setMunicipios(response);
            setLoadingMunicipios(false);
          } else{
            setErrorRequestMunicipios(true);
            setLoadingMunicipios(false);
          }
          
        }
        if (idEstado) {
          fetchMunicipios();
        }
      }, [idEstado]);

      useEffect(() => {
        setIdColonia(null);
        setErrorRequestColonias(false);
        setColonias([]);
        setTiendas([]);
        async function fetchColonias() {
         // console.log('cargo colonias');
          setLoadingColonias(true);
          const response = await getCol(idMunicipio);
          if (response ) {
            response.status ? setErrorRequestColonias(true) : setColonias(response);
            setLoadingColonias(false);
          } else{
            setErrorRequestColonias(true);
            setLoadingColonias(false);
          }
        }
        if (idMunicipio) {
          fetchColonias();
        }
      }, [idMunicipio]);

      useEffect(() => {
        setErrorRequestTiendas(false);
        setTiendas([]);
        async function fetchTiendas() {
         // console.log('cargo tiendas');
          setLoadingTiendas(true);
          const response = await getTiendas(idColonia);
          if (response ) {
            response.status ? setErrorRequestTiendas(true) : setTiendas(response);
            setLoadingTiendas(false);
          } else{
            setErrorRequestTiendas(true);
            setLoadingTiendas(false);
          }
        }
        if (idColonia) {
          fetchTiendas();
        }
      }, [idColonia]);

    
   

    return (
        <div className="contenedorElige">
            <div className="textoElegir">No pudimos acceder a tu ubicación, pero puedes seleccionar tu Estado, Municipio y Colonia para mostrarte puntos de recarga dentro de esa zona.</div>
               
              { !loadingEstados 
                  ? !errorRequestEstados
                    ? typeof estados != "undefined" && estados != null && estados.length != null && estados.length > 0
                      ? <div className="contSelect animate__animated animate__slideInLeft">
                         
                          <Autocomplete
                          id="combo-box-demo"
                          options={estados}
                          getOptionLabel={(edo) => edo.nombre}
                          onChange={(event, newValue) => {
                            if(newValue){
                              setIdEstado(newValue.id);
                            }
                           // console.log(newValue);
                          }}
                          renderInput={(params) => <TextField {...params} label="Selecciona un Estado" variant="outlined" />}
                        />

                     
                        
                          {/* <Select value={watchEdo|| ''}   {...register('edoId')} >
                  
                              {
                                  estados.map( (edo) => (
                                    <MenuItem key={ edo.id } value={edo.id}>{edo.nombre}</MenuItem>
                                ))
                              }
                          </Select> */}
                        </div>
                      : <p></p>
                    : <OfertaError/>
                :<div className="cargaTexto"> <LinearProgress /> Cargando estados...</div>
              }

              { !loadingMunicipios
                ? !errorRequestMunicipios
                  ? typeof municipios != "undefined" && municipios != null && municipios.length != null && municipios.length > 0
                    ? <div className="contSelect animate__animated animate__slideInLeft">
                        
                        <Autocomplete
                          id="combo-box-demo"
                          options={municipios}
                          getOptionLabel={(mun) => mun.nombre}
                          onChange={(event, newValue) => {
                            if(newValue){
                              setIdMunicipio(newValue.id);
                            }
                            
                          }}
                          renderInput={(params) => <TextField {...params} label="Selecciona un Municipio" variant="outlined" />}
                        />


                        {/* <Select value={watchMun|| ''} {...register('munId')}>
                
                            {
                                municipios.map( (mun) => (
                                        <MenuItem key={ mun.id } value={mun.id}>{mun.nombre}</MenuItem>
                                    ))
                            }
                        </Select> */}
                      </div>
                    : <p></p>
                  : <OfertaError/>
                : <div className="cargaTexto"> <LinearProgress /> Cargando municipios...</div>
              }

              { !loadingColonias
                ? !errorRequestColonias
                  ? typeof colonias != "undefined" && colonias != null && colonias.length != null && colonias.length > 0
                    ? <div className="contSelect animate__animated animate__slideInLeft">
                         
                         <Autocomplete
                          id="combo-box-demo"
                          options={colonias}
                          getOptionLabel={(col) => col.nombre}
                          onChange={(event, newValue) => {
                            if(newValue){
                              setIdColonia(newValue.id);
                            }
                            
                          }}
                          renderInput={(params) => <TextField {...params} label="Selecciona una Colonia" variant="outlined" />}
                        />
                        {/* <Select value={watchCol || ''} {...register('colId')}>
                            {
                                colonias.map( (col) => (
                                        <MenuItem key={ col.id } value={col.id}>{col.nombre}</MenuItem>
                                    ))
                            }
                        </Select> */}
                      </div>
                    : <p></p>
                  : <OfertaError/>
                : <div className="cargaTexto"> <LinearProgress /> Cargando colonias...</div>
              }

              { idColonia !== null
                  ?
                    !loadingTiendas
                      ? !errorRequestTiendas
                        ? tiendas.length > 0 
                          ? <div className="scrollTiendas2">
                              {
                                  tiendas.map( (tienda, i) => (
                                      <StoreItem key={ i } {...tienda}/>
                                      )
                                  )
                              }
                            </div>
                        : <p className="noTiendas">No encontramos puntos de recarga cercanos</p>
                      : <OfertaError/>
                    : <div className="cargaTexto"> <LinearProgress /> Cargando tiendas...</div>
                  : <p></p>
              }


        </div>
    )
}
